<template lang="pug">
    .poi-search
        el-autocomplete(size="small" v-model="poi" :fetch-suggestions="querySearch" placeholder="搜索地址" :trigger-on-focus="false" @select="handleSelect" suffix-icon="el-icon-search" @keydown.native="handleChange" clearable)
</template>

<script>
import storeMixin from '../../store/mixin';
export default {
    props: {},
    mixins: [storeMixin],
    data() {
        return {
            poi: null,
            item: null,
        };
    },
    methods: {
        async querySearch(queryString, cb) {
            const { data } = await this.REQUEST({
                url: `v2/tool/place/text?keywords=${queryString}`,
            });
            const recommends = data.pois.map(item => {
                item.value = item.name;
                return item;
            });
            cb(recommends);
        },
        handleSelect(item) {
            this.item = item;
            this.$emit(
                'select',
                item.location.split(',').map(v => +v)
            );
        },
        handleChange(e) {
            if (
                e.key == 'Enter' &&
                this.item &&
                this.item.name &&
                this.poi === this.item.name
            ) {
                this.$emit('select', [
                    ...this.item.location.split(',').map(v => +v),
                    new Date().valueOf(),
                ]);
            }
        },
    },
    mounted() {},
};
</script>

<style lang="stylus">
#canvas
    border-radius 10px
</style>
